










































































































































































































import debounce from 'lodash/debounce';

import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { mapGetters, mapState, mapActions } from 'vuex';
import { validationMixin } from 'vuelidate'

import { getFieldError } from '@/core/tools/forms/get_field_error';
import { required } from 'vuelidate/lib/validators'

import { STORE_KEY, store } from './_store';
import Attachments from '@/components/Controls/Attachments.vue';
import IncidentCombobox from '@/components/Controls/IncidentCombobox.vue';
import moment from 'moment';
import WarehouseTransitCombobox from "@/components/Controls/WarehouseTransitCombobox.vue";

@Component({
  mixins: [ validationMixin ],
  computed: {
    ...mapState(STORE_KEY, [
      'loaded', 'loading', 'fatalError',
      'document', 'form', 'meta', 'storages'
    ]),
    ...mapGetters(STORE_KEY, [
      'fields'
    ])
  },
  methods: {
    getFieldError
  },
  validations() {
    const rules: any = {
      incident_id: {  },
      disposal_id: {  },
      disposal_end_date: {  },
      disposal_start_date: {  },
      carantine_start_date: {  },
      carantine_end_date: {  },
      carantine_comment: {  },
      carantine_state: {  },
      recycling_start_date: {  },
      recycling_end_date: {  },
      recycling_finish_date: {  },
      accepted_comment: {  },
      warehouse_transit_id: {  },
      warehouse_transit_sub_id: {  },
      // @ts-ignore
      warehouse_transit_comment: this.fromState == 'to-done' ? { required } : {}
    }

    return {
      form: rules
    }
  },
  components: {
    Attachments,
    IncidentCombobox,
    WarehouseTransitCombobox
  }
})
export default class WarehousesPlanForm extends Vue {
  @Prop({ type: Boolean }) isNew!: boolean;
  @Prop({ type: Object }) documentPreview!: any;
  @Prop({ type: Object }) initParams!: any;
  @Prop({ type: String }) documentId!: any;
  @Prop({ type: String }) fromState!: any;

  document!: any;
  form!: any;
  relatedFactsList!: any


  public isSuggestionsFetching = false;
  public suggestions: any[] = [];
  public need_comment: boolean = false;

  public created() {
    // @ts-ignore
    if (!(STORE_KEY in this.$store._modules.root._children)) {
      this.$store.registerModule(STORE_KEY, store);
    }
  }

  get newDay(){
    return moment().hours()  < 9;
  }

  public mounted() {

    console.log('init', this.documentPreview)
    if (this.isNew) {
      this.$store.dispatch(`${STORE_KEY}/prepareNew`, this.initParams);
    } else {
      this.$store.dispatch(`${STORE_KEY}/init`, {
        id: this.documentPreview.id,
        documentPreview: this.documentPreview
      });
    }
  }

  changeValue(field: string, value: any) {
    this.$store.dispatch(`${STORE_KEY}/changeFormValue`, {
      field, newValue: value
    });

    // @ts-ignore
    // this.$v.form[field].$touch();
    // this.$v.form.$touch();
  }

  onWarehouseTransitSelect(warehouseTransit: any) {
    if (warehouseTransit) {
      let warehouse_transit_comment = warehouseTransit.label
      this.need_comment = false
      if (warehouseTransit.label.toLowerCase().includes('другое')) {
        this.need_comment = true
        warehouse_transit_comment = ''
      }
      this.$store.dispatch(`${STORE_KEY}/changeFormValue`, {
        field: 'warehouse_transit_comment',
        newValue: warehouse_transit_comment
      });
      this.$store.dispatch(`${STORE_KEY}/changeFormValue`, {
        field: warehouseTransit.id.includes('_sub_type') ? 'warehouse_transit_sub_type_id' : 'warehouse_transit_type_id',
        newValue: warehouseTransit.id
      });
    }
  }

  saveFormData() {
    this.$v.form.$touch()

    if(!this.$v.form.$error) {
      this.$store.dispatch(`${STORE_KEY}/saveForm`, this.documentPreview ? this.documentPreview.id : null)
      .then((result) => {
        this.$buefy.snackbar.open(`Данные успешно сохранены`);
        this.$v.form.$reset();

        this.$emit('form-close');
        (this.$parent as any).close();
      })
      .catch(() => {
        this.$buefy.snackbar.open({
          type: 'is-warning',
          message: `При сохранении возникли проблемы. Попробуйте позже.`
        })
      })
    }

  }

  beforeDestroy() {
    this.$store.dispatch(`${STORE_KEY}/reset`);
    // this.$store.unregisterModule(STORE_KEY);
  }
}

